"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripDescription = void 0;
const first_1 = __importDefault(require("lodash/first"));
const last_1 = __importDefault(require("lodash/last"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Configuration_1 = __importDefault(require("../../Configuration"));
const Driver_1 = require("../../controllers/Driver");
const Vendor_1 = require("../../controllers/Vendor");
const MomentHelper_1 = require("../../helpers/MomentHelper");
const BaseUser_1 = require("../../models/BaseUser");
const PrimaryAndSecondaryTripStatus_1 = require("../../models/PrimaryAndSecondaryTripStatus");
const Trip_1 = require("../../models/Trip");
const unwrap_1 = __importDefault(require("../../util/unwrap"));
const ModelDescription_1 = require("../ModelDescription");
const PhoneNumber_1 = require("../PhoneNumber");
const String_1 = require("../String");
const TripSource_1 = require("./TripSource");
const TripStatus_1 = require("./TripStatus");
const TripType_1 = require("./TripType");
exports.tripDescription = (0, ModelDescription_1.modelDescription)({
    properties: {
        id: (0, String_1.stringDescription)(),
        customerId: (0, String_1.stringDescription)(),
        driverId: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { userFacingTitle: 'driver', userFacingValue: async (id) => (0, BaseUser_1.baseUserFullName)(await (0, Driver_1.driverRead)(id, Configuration_1.default.getDatabase())), isOptional: true }),
        orderId: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { userFacingTitle: 'Order ID', isOptional: true }),
        status: TripStatus_1.tripStatusDescription,
        source: Object.assign(Object.assign({}, TripSource_1.tripSourceDescription), { userFacingTitle: 'source', isOptional: true }),
        type: TripType_1.tripTypeDescription,
        vendorId: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { userFacingTitle: 'vendor', userFacingValue: async (id) => (await (0, Vendor_1.vendorRead)(id, Configuration_1.default.getFirestore())).name, isOptional: true }),
    },
    derivedProperties: {
        date: {
            userFacingTitle: 'date',
            tableWidth: 'SM',
            getValue: Trip_1.firstScheduledTimestampMsWithDefault,
            userFacingValue: ts => (0, MomentHelper_1.momentFormatDate)((0, moment_timezone_1.default)(ts)),
        },
        driverPhone: Object.assign(Object.assign({}, PhoneNumber_1.phoneNumberDescription), { userFacingTitle: 'driver phone', getValue: trip => (0, unwrap_1.default)(trip.driver, BaseUser_1.baseUserPhoneSafe) }),
        primaryAndSecondaryStatus: PrimaryAndSecondaryTripStatus_1.primaryAndSecondaryTripStatusDescription,
        region: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { userFacingTitle: 'region', getValue: trip => { var _a, _b; return (_b = (_a = trip.locations) === null || _a === void 0 ? void 0 : _a.find(location => location.state)) === null || _b === void 0 ? void 0 : _b.state; } }),
        times: {
            userFacingTitle: 'times',
            getValue: trip => {
                var _a, _b;
                const locations = (0, Trip_1.tripLocationsWithDefault)(trip);
                const timestamps = [(_a = (0, first_1.default)(locations)) === null || _a === void 0 ? void 0 : _a.scheduledTimestampMs, (_b = (0, last_1.default)(locations)) === null || _b === void 0 ? void 0 : _b.scheduledTimestampMs];
                // const timeZoneIdentifier = locations.find(l => l.timeZoneIdentifier)?.timeZoneIdentifier;
                return timestamps
                    .map(timestamp => { var _a; return (_a = (0, unwrap_1.default)(timestamp, ts => (0, MomentHelper_1.momentFormatTime2)((0, moment_timezone_1.default)(ts).tz('America/New_York')))) !== null && _a !== void 0 ? _a : '-'; })
                    .join(' → ');
                // if (timeZoneIdentifier) {
                // } else {
                //   return timestamps.map(timestamp => unwrap(timestamp, ts => momentFormatTime2(moment(ts))) ?? '?').join(' → ');
                // }
            },
            userFacingValue: z => z,
        },
        title: {
            userFacingTitle: 'title',
            getValue: Trip_1.tripTitleShortest,
            userFacingValue: v => v,
        },
    },
});
/**
 * Actions
 * - duplicate
 * - edit
 * - cancel
 * - un/assign driver
 */
